import { Card, AccordionCollapse, FormGroup, FormLabel, FormSelect, InputGroup, FormControl } from "react-bootstrap"
import { SectionProps, TrainingField, YesOrNo } from "../Types/calculator"
import { errorStyles, isSectionComplete } from "../Utilities/constants"
import { SectionIndicators } from "./Common"
import { incrementDecrementArrows } from "../Utilities/interface"

export function Training(props: SectionProps<TrainingField>) {
  const { onCategorySelected, state, setSettings, section } = props
  const { expandedSections, driverTraining, driverHourlyPay, driverCoaching, managerHourlyPay } = state

  const complete = isSectionComplete(state, section)
  const validateDriverHourlyPay = section.fields["driverHourlyPay"].validationFunction
  const validateManagerHourlyPay = section.fields["managerHourlyPay"].validationFunction

  return (
    <Card id={section.name}>
      <Card.Header
        tabIndex={30}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onCategorySelected(section.name)}
        as="h3"
        onClick={() => onCategorySelected(section.name)}>
        <div style={{ fontWeight: complete ? "lighter" : "inherit" }}>{section.name}</div>
        <SectionIndicators
          error={!complete && expandedSections.includes(section.name)}
          complete={complete}
          tooltipMessage="Training drivers so they understand and trust the technology can improve safety outcomes. If your fleet trains drivers when introducing new technologies, please enter an amount that represents your drivers' hourly pay. We assume 2 hours per driver per year of training."
        />
      </Card.Header>
      <AccordionCollapse className="IncludeInExport" eventKey={section.name}>
        <Card.Body>
          <FormGroup>
            <FormLabel aria-label="Driver Training">
              Are you training the drivers on how the technology works?
              <FormSelect
                tabIndex={31}
                onChange={(ev) => setSettings({ driverTraining: ev.target.value as YesOrNo })}
                value={driverTraining}>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </FormSelect>
            </FormLabel>
          </FormGroup>
          {driverTraining === "Yes" && (
            <FormGroup>
              <FormLabel aria-label="Driver Hourly Pay">
                Driver Hourly Pay
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <FormControl
                    tabIndex={32}
                    value={Number(driverHourlyPay).toFixed(2)}
                    min={0}
                    step={0.01}
                    type="number"
                    onChange={(ev) => setSettings({ driverHourlyPay: parseFloat(ev.target.value) })}
                    onKeyDown={(ev) =>
                      incrementDecrementArrows({
                        ev,
                        field: "driverHourlyPay",
                        currency: true,
                        state,
                        setSettings,
                        onlyUpDown: true,
                      })
                    }
                    onBlur={(ev) => setSettings({ driverHourlyPay: parseFloat(ev.target.value) })}
                    style={!validateDriverHourlyPay(driverHourlyPay) ? errorStyles : undefined}
                  />
                </InputGroup>
              </FormLabel>
            </FormGroup>
          )}
          <br />
          <FormGroup>
            <FormLabel aria-label="Driver Coaching">
              Are you coaching the drivers using the technology?
              <FormSelect
                tabIndex={41}
                onChange={(ev) => setSettings({ driverCoaching: ev.target.value as YesOrNo })}
                value={driverCoaching ? driverCoaching : undefined}>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </FormSelect>
            </FormLabel>
          </FormGroup>
          {driverCoaching === "Yes" && (
            <FormGroup>
              <FormLabel aria-label="Manager Hourly Pay">
                Manager Hourly Pay
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <FormControl
                    tabIndex={42}
                    value={Number(managerHourlyPay).toFixed(2)}
                    min={0}
                    type="number"
                    step={0.01}
                    onChange={(ev) => setSettings({ managerHourlyPay: Number(ev.target.value) })}
                    onKeyDown={(ev) =>
                      incrementDecrementArrows({
                        ev,
                        field: "managerHourlyPay",
                        currency: true,
                        state,
                        setSettings,
                        onlyUpDown: true,
                      })
                    }
                    onBlur={(ev) => setSettings({ managerHourlyPay: Number(ev.target.value) })}
                    style={!validateManagerHourlyPay(managerHourlyPay) ? errorStyles : undefined}
                  />
                </InputGroup>
              </FormLabel>
            </FormGroup>
          )}
        </Card.Body>
      </AccordionCollapse>
    </Card>
  )
}